module.exports = __webpack_public_path__ + "static/media/bg_login.f6a7e631.jpg";